import React, { FC } from 'react';

import { CarouselQuotes } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';

export const LandingLoveStoriesContainer: FC = () => {
  return (
    <CarouselQuotes
      quotes={[
        {
          quote: lexemes.lxPageIndexLoveStoriesQuote,
          author: lexemes.lxPageIndexLoveStoriesAuthor('Leslie', 'Thomas', 2025),
          imageSrc: '/project-love/assets/love-stories-1.jpg',
          imageAlt: '',
          link: `/love-stories`,
          isSpeechmarkIncludedInText: true,
        },
      ]}
      linkText={lexemes.lxPageIndexLoveStoriesCtaButton}
    />
  );
};
